CCL.FasterToFunCategory = {
  autoload: [
    ['stateRoom', $('.custom-control.custom-checkbox.stateroom-check').length > 0]
  ],
  stateRoom() {
    $.each($('.custom-control.custom-checkbox.stateroom-check'), (index, element) => {
      $(element).on('click', (event) => {
        $('#ftf-add-to-cart').css('pointer-events', 'none');
        let bookingIdArray = '';
        $.each($('.custom-control.custom-checkbox.stateroom-check'), (i, element1) => {
          if ($(element1)[0].children[0].checked) {
            $('#ftf-add-to-cart').css('pointer-events', 'all');
            const p = $(element1)[0].children[0].getAttribute('data-bookingid');
            bookingIdArray += p ? (',').concat(p) : p;
          }
        });
        $('#ftf-add-to-cart').attr('data-bookingIds', bookingIdArray);
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-faster-to-fun/pdp-faster-to-fun.js